export function localeCompareArray(
  arr: PropertyKey[],
  brr: PropertyKey[]
): number {
  const minLen = Math.min(arr.length, brr.length)
  for (let i = 0; i < minLen; i++) {
    const compare = String(arr[i]).localeCompare(String(brr[i]))
    if (compare !== 0) return compare
  }
  return arr.length - brr.length
}
